import { Colors } from "@zapier/design-system";

export function DefaultNodeIcon({
  color = Colors.GrayWarm10,
}: {
  color?: string;
}) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.5"
        y="1.5"
        width="21"
        height="21"
        rx="3.5"
        stroke={color}
        strokeWidth="3"
      />
    </svg>
  );
}
